import { render, staticRenderFns } from "./PainelNoticias.vue?vue&type=template&id=69296584"
import script from "./PainelNoticias.vue?vue&type=script&lang=js"
export * from "./PainelNoticias.vue?vue&type=script&lang=js"
import style0 from "./PainelNoticias.vue?vue&type=style&index=0&id=69296584&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports